import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const projectTypeList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-project-type/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};
export const deliveryVerticalList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-delivery-verticals/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};
export const associatedRegionList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-associated-regions/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const projectTypeAdd = (params) => {
  return _baseClient.post('/unit-project-type/save', { body: params }).then((response) => {
    return response;
  });
};
export const deliveryVerticalAdd = (params) => {
  return _baseClient.post('/unit-delivery-verticals/save', { body: params }).then((response) => {
    return response;
  });
};
export const associatedRegionAdd = (params) => {
  return _baseClient.post('/unit-associated-regions/save', { body: params }).then((response) => {
    return response;
  });
};

export const projectTypeDelete = (params) => {
  return _baseClient.get('/unit-project-type/delete', params);
};
export const deliveryVerticalDelete = (params) => {
  return _baseClient.get('/unit-delivery-verticals/delete', params);
};
export const associatedRegionDelete = (params) => {
  return _baseClient.get('/unit-associated-regions/delete', params);
};

export const projectTypeDetail = (params) => {
  return _baseClient.get('/unit-project-type/get', params);
};
export const deliveryVerticalDetail = (params) => {
  return _baseClient.get('/unit-delivery-verticals/get', params);
};
export const associatedRegionDetail = (params) => {
  return _baseClient.get('/unit-associated-regions/get', params);
};

export const projectTypeUpdateStatus = (params) => {
  return _baseClient.get('/unit-project-type/update-status', params);
};
export const deliveryVerticalUpdateStatus = (params) => {
  return _baseClient.get('/unit-delivery-verticals/update-status', params);
};
export const associatedRegionUpdateStatus = (params) => {
  return _baseClient.get('/unit-associated-regions/update-status', params);
};
